import { queryClient } from 'App';
import useAppMutation from 'hooks/useAppMutation';
import useNotify from 'hooks/useNotify';
import API from 'services/API';
import { useTranslation } from 'react-i18next';
import { getErrorMessage } from 'utils/axiosExceptionUtils';
import { IntegrationEnum } from 'models/InternalIntegrationSetting';
import { INTERNAL_INTEGRATION_SETTINGS_BASE_QUERY_KEY } from 'pages/channels/integrationSettingsQuery';
import { INTEGRATION_PROPERTY_SETTINGS_QUERY_KEY } from 'hooks/useFetchIntegrationPropertySettings';

const useDeleteLockAssignment = () => {
  const { notifyError, notifySuccess } = useNotify();
  const { t } = useTranslation();

  return useAppMutation({
    mutationFn: async (payload: {
      enumId: IntegrationEnum;
      propertyUid: string;
      propertyName: string;
      integrationName: string;
    }) => {
      const { enumId, propertyUid } = payload;

      const response = await API.delete(
        `/api/internal/integrations/default/${enumId}/properties/${propertyUid}/lock`,
      );

      return response.data;
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [
          INTERNAL_INTEGRATION_SETTINGS_BASE_QUERY_KEY,
          INTEGRATION_PROPERTY_SETTINGS_QUERY_KEY,
          'detail',
        ],
      });
    },
    onSuccess: (_, { propertyName, integrationName }) => {
      notifySuccess(
        t('pageIntegrations.integrationDetails.lockDisconnected', {
          property: propertyName,
          integration: integrationName,
        }),
      );
    },
    onError: (error: any) => {
      notifyError(
        getErrorMessage({
          apiErrorCode: error.response?.data?.apiErrorCode,
          apiErrorMessage: error.response?.data?.apiErrorMessage,
          baseKey: 'pageIntegrations.apiErrorCodes.',
          t,
        }),
      );
    },
  });
};

export default useDeleteLockAssignment;
